export const checkParamExists = (location,param) => {
    return location.search.length ? location.search.includes(param) : location.pathname.length ? location.pathname.includes(param) : false
}